/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */

import { string } from 'prop-types';
import React from 'react';

import { contentConverter } from 'services/Content';

import './TransactionInfo.scss';

const TransactionInfo = ({ content }) => {
  const htmlContent = contentConverter.makeHtml(content);
  return (
    <div className="transactions-info-content">
      <span dangerouslySetInnerHTML={{ __html: htmlContent }} />
    </div>
  );
};

TransactionInfo.propTypes = {
  content: string.isRequired
};

TransactionInfo.defaultProps = {
  content: ''
};

export default TransactionInfo;
